import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import whatInput from 'what-input';
const Selector = (props) => {
    var _a, _b;
    const selectorRef = useRef(null);
    const menuRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [focusList, setFocusList] = useState(false);
    useLayoutEffect(() => {
        var _a, _b;
        if (open) {
            props.trackOpen ? props.trackOpen() : null;
            const menuHeight = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            if (selectorRef.current && menuHeight > selectorRef.current.offsetHeight) {
                selectorRef.current.style.height = `${menuHeight}px`;
                selectorRef.current.style.visibility = 'visible';
            }
        }
        else {
            (_b = selectorRef.current) === null || _b === void 0 ? void 0 : _b.removeAttribute('style');
        }
    }, [open]);
    useEffect(() => {
        setOpen(props.open);
    }, [props.open, props.currentItem]);
    return (React.createElement("div", { className: classNames(props.className), ref: selectorRef, onMouseEnter: () => {
            whatInput.ask() === 'mouse' && !props.disableHover && props.children.length !== 1 && setOpen(true);
        }, onMouseLeave: () => {
            !props.disableHover && !props.open && props.children.length !== 1 && setOpen(false);
        } },
        React.createElement("fieldset", { ref: menuRef, className: classNames('selector__menu'), id: props.selectorId, tabIndex: -1 },
            React.createElement("legend", { className: "visually-hidden" }, props.unselectedLabel),
            (!(props === null || props === void 0 ? void 0 : props.hideLabel) || (props === null || props === void 0 ? void 0 : props.hideValue)) && (React.createElement("div", { className: "selector__menu-labels" },
                !(props === null || props === void 0 ? void 0 : props.hideLabel) && (React.createElement("span", { className: "selector__menu-label label", id: props.selectorId + '-title' }, (_a = props.selectLabel) !== null && _a !== void 0 ? _a : props.selectedLabel,
                    ":")),
                !(props === null || props === void 0 ? void 0 : props.hideValue) && React.createElement("span", { className: "selector__menu-value" }, props.itemType === 'string' ? props.currentItem : (_b = props.currentItem) === null || _b === void 0 ? void 0 : _b.displayValue))),
            React.createElement("div", { role: props.listRole || null, className: classNames('selector__menu-list', { focused: focusList }), onFocus: () => {
                    // handles color labels show/hide on keyboard focus
                    setFocusList(true);
                }, onBlur: () => {
                    // handles color labels show/hide on keyboard focus
                    setFocusList(false);
                } }, props.children))));
};
Selector.defaultProps = {
    swatchable: false,
    enableOutofstockLabel: false,
    hideValue: false,
    itemType: 'object',
};
export default Selector;
